import React, { useEffect, useRef, useState } from "react"
import { Form } from "react-bootstrap"
import { formatInteger } from "../../utils/common/utils"
import Icon from "../icon/icon.component"
import ClipSpinner from "../spinner/ClipSpinner"
import { QuantityInputWithActionsProps } from "../types/input"
import "./QuantityInputWithActionsStyles.scss"

export const QuantityInputWithActions = (props: QuantityInputWithActionsProps) => {
    const [originalValue, setOriginalValue] = useState(props.value || 0)
    const [value, setValue] = useState(props.value || 0)
    const [isFocused, setIsFocused] = useState(false)
    const [isBlur, setIsBlur] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [isDisabled, setIsDisabled] = useState(false)
    const inputGroupRef = useRef<HTMLDivElement>(null)

    useEffect(() => {
        setIsLoading(false)
        setIsDisabled(false)
        setIsFocused(false)
        setIsBlur(true)
    }, [props.value])
    
    const onFocus = () => {
        setIsFocused(true)
        setIsBlur(false)
    }

    const handleBlur = (event: React.FocusEvent<HTMLInputElement>) => {
        const { relatedTarget } = event

        if (inputGroupRef.current && !inputGroupRef.current.contains(relatedTarget as Node)) {
            handleClose()
        }
    }

    const handleChange = (e) => {
        e.preventDefault()
        const qty = formatInteger(e.target.value)
        setValue(qty)
    }

    const handleSave = () => {
        if (value !== originalValue) {
            setIsLoading(true)
            setIsDisabled(true)
            props.onSaveCallback(value)
            setOriginalValue(value)
        }
    }

    const handleClose = () => {
        if (!isLoading) {
            setIsBlur(true)
            setTimeout(() => {
                setIsFocused(false)
                setValue(originalValue)
            }, 230)
        }
    }

    return (
        <div 
            className={"input-group input-group-container "}
            onBlur={handleBlur}
            ref={inputGroupRef}
        >
            <Form.Control
                id={props.id}
                key={props.id}
                name={props.name}
                value={value}
                type={props.type}
                className={"form-control"}
                onFocus={onFocus}
                onChange={e => handleChange(e)}
                disabled={isDisabled}
            />
            {isFocused 
                ? <div className={"input-group-append input-group-button-container " + (!isBlur ? "fade-in" : "fade-out")}>
                    <button 
                        className={"input-group-text btn btn-outline-success" + (isLoading ? " input-save-loading" : "")}
                        onClick={() => handleSave()}
                    >
                        {!isLoading 
                            ? <Icon value="check" className="pr-1" />
                            : <ClipSpinner 
                                height="20px"
                                width="24px"
                                size={16}
                            />
                        }
                        
                    </button>
                    <button className="input-group-text btn-outline-secondary" onClick={() => handleClose()}>
                        <Icon value="times" className="pr-1" />
                    </button>
                </div>
                : <></>
            }
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/common/inputs/QuantityInputWithActions.tsx